import { IconVal } from "../internal-components/top-nav/top-nav.component";
import { BaseViewModel } from "./base.viewmodel";

export class TopNavViewModel implements BaseViewModel {
    PageTitle: string = 'Top Nav';
   

    showMenu: boolean = false;
    sticky: boolean = false;
    subMenu: boolean = false;
    showIconWhite: boolean = true;
    showIconBlack: boolean = false;
    status: boolean = false;
    iconView: IconVal = IconVal.black;
    elementPosition: any;
}
